import { cn } from "@punchup/utils/cn";

/**
 * Standard helper text describing the accepted profile photo format and size
 * constraints. Shared across the comedian profile editor and the venue-manager
 * "add comedian" photo modal so the wording stays in sync.
 */
export function PhotoRequirementsText({ className }: { className?: string }) {
  return (
    <p className={cn("text-sm text-gray-500", className)}>
      The photo must be a JPEG, PNG, or WEBP file smaller than 10MB and at least
      150px by 150px.
    </p>
  );
}
